export default __webpack_public_path__ + "static/media/to-do.8fa24304.svg";